export default function(Vue) {
	// Vue Material components function override

	// MdPopover creates multiple scroll/resize event listeners
	// http://redmine.mns.vc/issues/375
	// a workaround and also a better feature is to disable the
	// Popper option eventsEnabled, see https://popper.js.org/docs/v1/#defaultseventsenabled
	// override medhod getPopperOptions in lib/node_modules/vue-material/src/components/MdPopover/MdPopover.vue
	const MdPopoverMethodsGetPopperOptions = function() {
		return {
			eventsEnabled: false, // the only line added compared to original method
			placement: "bottom",
			modifiers: {
				preventOverflow: {
					boundariesElement: "viewport",
					padding: 16
				},
				computeStyle: {
					gpuAcceleration: false
				}
			},
			onCreate: () => {
				this.shouldActivate = true;
				this.$emit("md-active");
			}
		};
	};

	// this is all the registered components where MdPopper is used
	Vue.options.components.
	MdDatepicker.options.components.
	MdDatepickerDialog.components.
	MdPopover.methods.getPopperOptions = MdPopoverMethodsGetPopperOptions;

	Vue.options.components.
	MdMenuContent.options.components.
	MdPopover.methods.getPopperOptions = MdPopoverMethodsGetPopperOptions;

	Vue.options.components.
	MdTooltip.options.components.
	MdPopover.methods.getPopperOptions = MdPopoverMethodsGetPopperOptions;

	// suppress all key events on MdMenu except escape (to prevent using arrow keys for selection which is buggy)
	Vue.options.components.MdMenuContent.options.methods.keyNavigation = function(event) {
		switch (event.key) {
			case "Escape":
				this.onEsc();
				break;
		}
	};
}
